import './About.css';
import { useEffect } from 'react';
import ProfilePhoto from './IMAGE/KALAW.jpeg';

function About({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">

      {/* Top nav bar (removed for global navbar) */}

      {/* --- HERO STRIP --- */}
      <div className="about-hero-strip">
        <div className="strip-inner">
          <p className="strip-label">Personal Profile</p>
          <h1 className="strip-name">About Me</h1>
          <p className="strip-role">Exploring the intersection of hardware and software engineering.</p>
          <div className="hero-stats-row">
            <span className="hero-stat-pill">▸ Batangas, Philippines</span>
            <span className="hero-stat-pill">▸ Computer Engineering</span>
            <span className="hero-stat-pill">▸ Aspiring Developer</span>
          </div>
          <div className="hero-watermark">●</div>
        </div>
      </div>

      {/* Main content */}
      <main className="about-main">

        {/* — Left column — */}
        <aside className="about-sidebar">
          <div className="sidebar-photo-wrap">
            <img src={ProfilePhoto} alt="Christian D. Kalaw" className="sidebar-photo" />
            <div className="photo-caption">Christian D. Kalaw</div>
          </div>

          <div className="sidebar-block">
            <h3 className="sidebar-block-title">Details</h3>
            <ul className="detail-list">
              <li className="detail-row">
                <span className="detail-key">Location</span>
                <span className="detail-val">Philippines</span>
              </li>
              <li className="detail-row">
                <span className="detail-key">Field</span>
                <span className="detail-val">Computer Engineering</span>
              </li>
              <li className="detail-row">
                <span className="detail-key">Instrument</span>
                <span className="detail-val">Guitar</span>
              </li>
              <li className="detail-row">
                <span className="detail-key">Status</span>
                <span className="detail-val detail-status">Open to opportunities</span>
              </li>
            </ul>
          </div>

          <div className="sidebar-block">
            <h3 className="sidebar-block-title">What drives me</h3>
            <div className="pill-list">
              <span className="pill">Innovator</span>
              <span className="pill">Goal-Oriented</span>
              <span className="pill">Lifelong Learner</span>
              <span className="pill">Team Player</span>
            </div>
          </div>
        </aside>

        {/* — Right column — */}
        <section className="about-content">

          {/* Bio */}
          <div className="content-block">
            <h2 className="content-title">Who I Am</h2>
            <div className="title-rule"></div>
            <p className="bio-text">
              I'm <strong>Christian D. Kalaw</strong>, a Computer Engineering student with a deep-rooted passion for understanding how technology works from the ground up. I chose this field because I've always been fascinated by the magic that happens at the intersection of hardware and software — how lines of code can breathe life into physical circuits.
            </p>
            <p className="bio-text">
              My core strength lies in my adaptability and problem-solving mindset. Whether I'm designing embedded systems, architecting databases, or writing full-stack web applications, I approach every challenge as an opportunity to innovate. I thrive in environments that require both logical precision and creative thinking.
            </p>
            <p className="bio-text">
              Looking forward, my goal is to become a versatile <strong>Software Developer</strong> who builds scalable, high-impact solutions. I'm particularly interested in roles where I can leverage my understanding of low-level systems to write highly efficient, optimized software that makes a tangible difference in people's lives.
            </p>
          </div>

          {/* Stats bar */}
          <div className="stats-bar">
            <div className="stat-item">
              <span className="stat-num">4x</span>
              <span className="stat-lbl">Academic Honors</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-num">3rd</span>
              <span className="stat-lbl">Year Eng.</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-num">10+</span>
              <span className="stat-lbl">Core Skills</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <span className="stat-num">100%</span>
              <span className="stat-lbl">Dedication</span>
            </div>
          </div>

          {/* Strengths Section */}
          <div className="content-block my-strengths">
            <h2 className="content-title">My Strengths</h2>
            <div className="title-rule"></div>
            <div className="strengths-grid">
              <div className="strength-card">
                <div className="strength-icon">🧠</div>
                <h3 className="strength-title">Adaptability</h3>
                <p className="strength-desc">Quick to learn and integrate new technologies, frameworks, and methodologies into my workflow regardless of the domain.</p>
              </div>
              <div className="strength-card">
                <div className="strength-icon">🧩</div>
                <h3 className="strength-title">Problem Solving</h3>
                <p className="strength-desc">A highly analytical approach to breaking down complex technical challenges into manageable, logical, and efficient solutions.</p>
              </div>
              <div className="strength-card">
                <div className="strength-icon">📈</div>
                <h3 className="strength-title">Continuous Growth</h3>
                <p className="strength-desc">Dedicated to lifelong learning, constantly refining my skills, and staying ahead of the curve in a fast-paced industry.</p>
              </div>
              <div className="strength-card">
                <div className="strength-icon">🤝</div>
                <h3 className="strength-title">Communication</h3>
                <p className="strength-desc">Articulating complex technical concepts clearly to diverse teams, ensuring smooth collaboration from concept to deployment.</p>
              </div>
            </div>
          </div>

          {/* Hobbies */}
          <div className="content-block mt-xl">
            <h2 className="content-title">Outside the Code</h2>
            <div className="title-rule"></div>
            <p className="bio-text">
              My interests outside engineering shape how I think, communicate, and create.
            </p>

            <div className="hobby-grid theme-accent-style">

              <div className="hobby-item">
                <div className="hobby-index-col">
                  <span className="hobby-index">01</span>
                  <div className="hobby-line"></div>
                </div>
                <div className="hobby-body">
                  <h4 className="hobby-title">Online Gaming</h4>
                  <p className="hobby-blurb">
                    Competitive gaming sharpens strategic thinking and quick decisions.
                  </p>
                  <div className="hobby-tags">
                    <span className="htag">Strategy</span>
                    <span className="htag">Competitive</span>
                  </div>
                </div>
              </div>

              <div className="hobby-item">
                <div className="hobby-index-col">
                  <span className="hobby-index">02</span>
                  <div className="hobby-line"></div>
                </div>
                <div className="hobby-body">
                  <h4 className="hobby-title">Travelling</h4>
                  <p className="hobby-blurb">
                    Every destination teaches something new about people and systems.
                  </p>
                  <div className="hobby-tags">
                    <span className="htag">Culture</span>
                    <span className="htag">Adventure</span>
                  </div>
                </div>
              </div>

              <div className="hobby-item">
                <div className="hobby-index-col">
                  <span className="hobby-index">03</span>
                  <div className="hobby-line"></div>
                </div>
                <div className="hobby-body">
                  <h4 className="hobby-title">Playing with Pets</h4>
                  <p className="hobby-blurb">
                    Resets the mind. Teaches patience and staying present.
                  </p>
                  <div className="hobby-tags">
                    <span className="htag">Wellness</span>
                    <span className="htag">Joy</span>
                  </div>
                </div>
              </div>

              <div className="hobby-item">
                <div className="hobby-index-col">
                  <span className="hobby-index">04</span>
                  <div className="hobby-line"></div>
                </div>
                <div className="hobby-body">
                  <h4 className="hobby-title">Playing Guitar</h4>
                  <p className="hobby-blurb">
                    Music is my creative counterbalance. Learning pieces trains patience and precision.
                  </p>
                  <div className="hobby-tags">
                    <span className="htag">Music</span>
                    <span className="htag">Creative</span>
                  </div>
                </div>
              </div>

              <div className="hobby-item">
                <div className="hobby-index-col">
                  <span className="hobby-index">05</span>
                  <div className="hobby-line"></div>
                </div>
                <div className="hobby-body">
                  <h4 className="hobby-title">Exploring New Things</h4>
                  <p className="hobby-blurb">
                    Actively seeking unfamiliar tools and fields to step outside the comfort zone.
                  </p>
                  <div className="hobby-tags">
                    <span className="htag">Curiosity</span>
                    <span className="htag">Growth</span>
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* Philosophy quote */}
          <blockquote className="philosophy-quote">
            "The people who are crazy enough to think they can change the world are the ones who do."
            <cite>— Steve Jobs</cite>
          </blockquote>

          {/* CTA */}
          <div className="about-cta">
            <button className="cta-primary" onClick={onNavigateHome}>
              View My Work
            </button>
            <a href="mailto:christian@example.com" className="cta-secondary">
              Get In Touch
            </a>
          </div>

        </section>
      </main>

      {/* Footer */}
      <footer className="about-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>

    </div>
  );
}

export default About;
